import axios from 'axios'
import queryString from 'query-string'
import { VirtualCardSecureResponse } from 'src/models/virtualCard.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import {
  PostBulkVirtualCardResponse,
  VirtualCardsFiltersBody,
  VirtualCardsResponse,
} from 'src/queries/virtualCards.models'
import { PostBulkVirtualCardRequest } from 'src/requests/postBulkVirtualCard.request'

// Imperative single-card read against the VGS vault, for the Pusher sync path.
// Mirrors the endpoint the detail query (useQueryVirtualCardDetail) uses, so a
// fetched card is a drop-in for the detail + list caches. This is the
// rate-limited upstream read — callers must gate it (see pusherEntitySync).
export const getVirtualCardDetail = async (
  virtualCardId: string,
): Promise<VirtualCardSecureResponse> => {
  const { virtualCard } = await getResponseData(
    axios.get<{ virtualCard: VirtualCardSecureResponse }>(
      `/virtualcards/${virtualCardId}`,
      getRequestConfig(RequestConfig.Vault),
    ),
  )
  return virtualCard
}

export const getVirtualCards = async ({
  filters,
  page,
  count,
}: {
  filters: VirtualCardsFiltersBody | undefined
  page: number
  count: number
}): Promise<VirtualCardsResponse> => {
  return getResponseData(
    axios.get<VirtualCardsResponse>(
      `virtualcards?${queryString.stringify({ ...filters, page, count })}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

// Creates virtual cards in bulk (one or more recipients). Replaces the write
// path of the legacy `postBulkVirtualCardAndOpenToastAndCloseFlyout` thunk.
export const postBulkVirtualCard = async (
  body: Partial<PostBulkVirtualCardRequest>,
): Promise<PostBulkVirtualCardResponse> => {
  return getResponseData(
    axios.post<PostBulkVirtualCardResponse>(
      `/virtualcards/bulk`,
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
